import { createSlice } from "@reduxjs/toolkit";
import {
  getOrderList,
  onCancelOrder,
  getOrderDetailById,
} from "../thunks/orderThunk";

const initialState = {
  isOrderListing: false,
  getOrders: [],
  pagination: {
    current_page: 1,
    total_pages: 1,
    total_records: 0,
  },
  tabCounts: {
    all: 0,
    pending: 0,
    delivered: 0,
    canceled: 0,
  },
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrderList.pending, (state) => {
        state.isOrderListing = true;
      })
      .addCase(getOrderList.fulfilled, (state, action) => {
        state.isOrderListing = false;

        const payload = action.payload;

        // ✅ Make sure getOrders is ALWAYS an array of order objects
        state.getOrders = Array.isArray(payload.data?.orders)
          ? payload.data.orders
          : [];

        state.pagination.current_page = payload.data?.current_page || 1;
        state.pagination.total_pages = payload.data?.total_pages || 1;
        state.pagination.total_records = payload.data?.total_records || 0;

        if (payload.data?.tab_counts) {
          state.tabCounts = {
            all: payload.data.tab_counts.all || 0,
            pending: payload.data.tab_counts.pending || 0,
            delivered: payload.data.tab_counts.delivered || 0,
            cancelled:
              payload.data.tab_counts.canceled ??
              payload.data.tab_counts.cancelled ??
              0,
          };
        }
      })

      .addCase(getOrderList.rejected, (state) => {
        state.isOrderListing = false;
      })
      .addCase(onCancelOrder.pending, (state) => {
        state.isOrderListing = true;
      })
      .addCase(onCancelOrder.fulfilled, (state, action) => {
        state.isOrderListing = false;
        state.action = action.payload;
      })
      .addCase(onCancelOrder.rejected, (state) => {
        state.isOrderListing = false;
      })
      .addCase(getOrderDetailById.pending, (state) => {
        state.isOrderListing = true;
      })
      .addCase(getOrderDetailById.fulfilled, (state, action) => {
        state.isOrderListing = false;
        state.action = action.payload;
      })
      .addCase(getOrderDetailById.rejected, (state) => {
        state.isOrderListing = false;
      });
  },
});

export default orderSlice.reducer;
